import { useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useAlert } from 'react-alert';
import { MenuDayTable } from './MenuDayTable';
import { SaveButton } from '../../../../../components/buttons/SaveButton';
import { PlusButton } from '../../../../../components/buttons/PlusButton';
import { DropdownSelect } from '../../../../../components/dropdown/DropdownSelect';
import { getDayMenu, saveMenuDay } from '../MenuService';
import { useNavigate } from 'react-router-dom';
import { BackButton } from '../../../../../components/buttons/BackButton';
import { SearchDropdownSelect } from '../../../../../components/dropdown/SearchDropdownSelect';

const MenuDayRecipesForm = () => {
    const { t } = useTranslation('monthMenu');
    const alert = useAlert();
    const navigate = useNavigate();
    const menuDayNumber = useSelector((state) => state.menuDay.dayNumber);
    const [selectedRecipeId, setSelectedRecipeId] = useState(-1);
    const [recipes, setRecipes] = useState([]);
    const [selectData, setSelectData] = useState([{ id: -1, name: t('common:SELECT') }]);
    const [meals, setMeals] = useState([]);
    const [selectedMeal, setSelectedMeal] = useState(1);
    const [menuDay, setMenuDay] = useState({
        recipes: [],
        dayNumber: 0,
        carbohydratesCradle: 0,
        carbohydrates: 0,
        proteinsCradle: 0,
        proteins: 0,
        fatCradle: 0,
        fat: 0,
        energyValueKcalCradle: 0,
        energyValueKcal: 0,
    });

    useEffect(() => {
        getDayMenu(menuDayNumber)
            .then((response) => {
                setMenuDay(response.data.menuDay);
                setRecipes(response.data.allRecipesList);
                setSelectData(selectData.concat(response.data.allRecipesList.map(it => ({
                    id: it.id,
                    name: it.title,
                }))));
            })
            .catch(() => alert.error(t('alert:loadingError')));
        setupMeals();
    }, []);

    const setupMeals = () => {
        setMeals([
            { id: 1, name: t('BREAKFAST') },
            { id: 2, name: t('LUNCH') },
            { id: 3, name: t('DINNER') },
            { id: 4, name: t('SNACK') }]);
    };

    const addRecipe = () => {
        let recipe = recipes.filter(recipe => recipe.id === selectedRecipeId)[0];
        if (recipe != null) {
            setMenuDay({
                ...menuDay,
                recipes: menuDay.recipes.concat({ ...recipe, mealId: selectedMeal }),
                carbohydratesCradle: menuDay.carbohydratesCradle + recipe.allCarbohydratesCradle,
                carbohydrates: menuDay.carbohydrates + recipe.allCarbohydrates,
                proteinsCradle: menuDay.proteinsCradle + recipe.allProteinsCradle,
                proteins: menuDay.proteins + recipe.allProteins,
                fatCradle: menuDay.fatCradle + recipe.allFatCradle,
                fat: menuDay.fat + recipe.allFat,
                energyValueKcalCradle: menuDay.energyValueKcalCradle + recipe.allEnergyValueKcalCradle,
                energyValueKcal: menuDay.energyValueKcal + recipe.allEnergyValueKcal,
            });
        }
    };

    const removeRecipe = (recipe) => {
        if (recipe != null) {
            menuDay.recipes.splice(menuDay.recipes.indexOf(recipe), 1);
            setMenuDay({
                ...menuDay,
                carbohydratesCradle: menuDay.carbohydratesCradle - recipe.allCarbohydratesCradle,
                carbohydrates: menuDay.carbohydrates - recipe.allCarbohydrates,
                proteinsCradle: menuDay.proteinsCradle - recipe.allProteinsCradle,
                proteins: menuDay.proteins - recipe.allProteins,
                fatCradle: menuDay.fatCradle - recipe.allFatCradle,
                fat: menuDay.fat - recipe.allFat,
                energyValueKcalCradle: menuDay.energyValueKcalCradle - recipe.allEnergyValueKcalCradle,
                energyValueKcal: menuDay.energyValueKcal - recipe.allEnergyValueKcal,
            });
        }
    };

    const saveDayMenu = () => {
        saveMenuDay(menuDay)
            .then(() => {
                alert.success(t('alert:saveSuccess'));
                navigate('/menu');
            })
            .catch(() => alert.error(t('alert:saveError')));
    };

    const plusButtonDisabled = () => {
        return selectedRecipeId === -1 || mealContainsRecipe();
    };

    const mealContainsRecipe = () => {
        return menuDay.recipes.filter(it => it.mealId === selectedMeal && it.id === selectedRecipeId).length > 0;
    };

    const saveMenuButtonDisabled = () => {
        return menuDay.recipes.filter(item => item.mealId === 1).length === 0
            || menuDay.recipes.filter(item => item.mealId === 2).length === 0
            || menuDay.recipes.filter(item => item.mealId === 3).length === 0;
    };

    return (
        <Container>
            <h1>{menuDay.dayNumber} {t('menuDay')} </h1>
            <div className={'selection-box'}>
                <SearchDropdownSelect id={selectedRecipeId}
                                      onSelect={(id) => setSelectedRecipeId(id)}
                                      data={selectData}>
                </SearchDropdownSelect>
                <div className={'fixed-selections'}>
                    <DropdownSelect id={'meals'} onSelect={setSelectedMeal} data={meals}></DropdownSelect>
                    <PlusButton onClick={addRecipe} disabled={plusButtonDisabled()}></PlusButton>
                    <SaveButton onClick={saveDayMenu} disabled={saveMenuButtonDisabled()}></SaveButton>
                    <BackButton link={'/menu'}></BackButton>
                </div>
            </div>
            <div>
                <MenuDayTable menu={menuDay} onRemove={removeRecipe}></MenuDayTable>
            </div>
        </Container>
    );
};
export default MenuDayRecipesForm;
